import SEO from '../../components/SEO'
import React, { useEffect } from "react"
import FindVehicleMain from "./FindVehicleMain"

const FindVehicle = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      {/* Silent redirect step; it has no head tags of its own, so without
          this it inherits the SPA fallback's (the homepage's). */}
      <SEO title="Redirecting" description="Taking you to your vehicle selection." noindex />
      <FindVehicleMain />
    </div>
  )
}

export default FindVehicle
